import React, { Component } from 'react';

import CMPHeader from './CMPHeader';
import CMPCookiesTable from './CMPCookiesTable';
import CMPFooter from './CMPFooter';

export default class CMPCookiesList extends Component {

    render() {
        return (
            <>
                <CMPHeader />
                <CMPCookiesTable />
                <CMPFooter />
            </>
        );
    }

}
